import React, { useState, useEffect } from 'react';
import { List, Typography } from '@material-ui/core';
import { Redux, Slices } from 'spwa-ui-library';
import ProductOption from '../ProductOption/index.jsx';
import ProductOptionCheckbox from '../ProductOptionCheckbox';
import ProductOptionStepper from '../ProductOptionStepper';
import css from './index.module.scss';
import { Button } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
// SPWA LIBRARY IMP
import { subProductsGA } from 'spwa-ui-library/esm/utils/helperGA.js';
import { useLocation } from '@reach/router';
const { useSelector, useDispatch } = Redux;
const { updateCart, updateProductPayload } = Slices.tempCartSlice;
const { selectProductEntities } = Slices.productSlice;

function ProductOptionGroup({
  productID,
  mainItem,
  optionGroup,
  id,
  selectedProduct,
  setCheckDependent,
  resetDependent,
  isDesktop,
  uniqueName,
  variantImageBase,
}) {
  const intl = useIntl();

  const productsMap = useSelector(selectProductEntities);
  const location = useLocation();
  const locationSearch = new URLSearchParams(location.search);
  const isBundleItem = locationSearch.has('main_product') || false;
  const mainProductId = locationSearch.get('main_product');
  let stepId = locationSearch.get('step');

  const mainProductInfo = productsMap[isBundleItem ? mainProductId : productID];

  if (mainProductInfo?.bundleTypeId == 'bundle' && mainProductInfo?.typeId == 'simple') {
    stepId = mainProductInfo?.steps[0]?.id || 1;
  }

  const [checkboxChecked, setCheckboxChecked] = useState([]);
  const [radioChecked, setRadioChecked] = useState(-1);
  const [status, setStatus] = useState('initial');
  const [moreValue, setMoreValue] = useState(false);
  const dispatch = useDispatch();

  const {
    type,
    subtitle: title,
    subtitle,
    options,
    isTopping,
    id: optionId,
    maximum,
  } = optionGroup;

  const isSingleSelectionOption = maximum === 1;

  const tempItems = useSelector((state) => state.tempCart);
  const productCustomization = tempItems.data?.items?.find(
    (product) => product.id == (isBundleItem ? mainProductId : productID)
  );

  let selectedToppingsCount = 0;

  if (isBundleItem) {
    if (productCustomization?.['bundle']?.[stepId]?.[productID]?.['items']) {
      let keys = Object.keys(productCustomization['bundle'][stepId][productID]['items']);
      selectedToppingsCount =
        Object.values(
          productCustomization['bundle'][stepId][productID]['items'][optionId] || {}
        ).reduce((acc, item) => acc + (item?.qty || 1), 0) || 0;
    }
  } else {
    if (productCustomization?.['items']) {
      let keys = Object.keys(productCustomization?.['items']);
      selectedToppingsCount =
        Object.values(productCustomization['items'][optionId] || {}).reduce(
          (acc, item) => acc + (item?.qty || 1),
          0
        ) || 0;
    }
  }

  useEffect(() => {
    setRadioChecked(-1);
  }, [resetDependent]);

  const handleToggle = (value) => {
    if (type === 'checkbox') {
      const currentIndex = checkboxChecked.indexOf(value);
      const newChecked = [...checkboxChecked];
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setCheckboxChecked(newChecked);
    }
    if (type === 'radio') {
      let condiments = moreValue === false ? filterValue : itemM;
      let option = condiments[value];
      const newOption = { ...option, selectionQty: option.selectionQty + 1 };
      let newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));
      let product;
      if (isBundleItem) {
        product = newProductCustomization['bundle']?.[stepId]?.[productID];
      } else {
        product = newProductCustomization;
      }

      if (!product?.items) {
        product = product || {};
        product['items'] = {};
      }

      if (!product.items[optionGroup?.id]) {
        product.items[optionGroup?.id] = {};
      }

      let previous = JSON.parse(JSON.stringify(product.items[optionGroup?.id] || {}));

      if (Object.keys(previous).length) {
        let previousId = Object.keys(previous)[0];
        let previousInfo = optionGroup?.options?.find((og) => og?.id == previousId);

        if (previousInfo && previousInfo?.default) {
          if (!newProductCustomization.removed) {
            newProductCustomization.removed = {};
          }
          if (!Object.values(newProductCustomization.removed || {}).includes(previousInfo.title)) {
            newProductCustomization.removed[previousInfo.id] = previousInfo.title;
          }
        }
      }

      product.items[optionGroup?.id] = {};
      product.items[optionGroup?.id][option.id] = {};

      product.items[optionGroup?.id][option.id]['qty'] = 1;

      if (isBundleItem) {
        newProductCustomization['bundle'][stepId][productID] = product;
      } else {
        newProductCustomization = product;
      }
      if (!option.default) {
        if (!newProductCustomization.added) {
          newProductCustomization.added = {};
          newProductCustomization.added[option.id] = option.title;
        } else {
          newProductCustomization.added[option.id] = option.title;
        }
      } else {
        if (newProductCustomization.removed) {
          delete newProductCustomization.removed[option.id];
        }
      }
      dispatch(
        updateProductPayload({
          data: newProductCustomization,
        })
      );
      subProductsGA(newOption.name, selectedProduct.name);
    }
    subProductsGA(options[radioChecked]?.title, selectedProduct.name);
  };

  let itemM = options;

  let bundleScrollId = `${title.replace(/[\W_]/g, '').split(' ').join('')}-${id}`;

  const filterValue =
    itemM &&
    itemM.filter((value, index) => {
      if (index < 50) {
        return value;
      }
      return null;
      // eslint:fix
    });
  return (
    <>
      <div className={css.root} id={`${bundleScrollId}`}>
        <Typography
          variant="h2"
          className={classNames(css.listTitle, {
            [css.currentActiveLink]:
              isDesktop && uniqueName === localStorage.getItem('activeIndex'),
          })}
        >
          {subtitle}
          {type === 'stepper' && !isTopping ? (
            <></>
          ) : (
            <>
              {type === 'checkbox' ? (
                ''
              ) : (
                <span>
                  {intl.formatMessage(
                    { id: 'toppings_selected_subtitle' },
                    {
                      num1: selectedToppingsCount,
                      num2: maximum || options?.length || 0,
                    }
                  )}
                </span>
              )}
            </>
          )}
        </Typography>
        <div className={css.listWrapper}>
          {(moreValue === false ? filterValue : itemM)?.map((condiment, idx) => {
            const key = `${id}-ProductOption-${condiment.position}-${condiment.sku}`;
            let isChecked = false;
            if (type === 'checkbox' || isTopping) {
              isChecked = checkboxChecked.indexOf(idx) > -1;
              return (
                <List disablePadding key={idx + Math.random()} className={css.listContainerCheck}>
                  <ProductOptionCheckbox
                    mainItem={productsMap[productID]}
                    option={condiment}
                    optionId={optionId}
                    type={type}
                    key={key}
                    id={key}
                    onChange={(event, value) => handleToggle(idx)}
                    checked={isChecked}
                    bundlePosition={optionGroup.id}
                    selectedProduct={selectedProduct}
                    productID={productID}
                    disabled={selectedToppingsCount >= maximum}
                    maximum={maximum}
                  />
                </List>
              );
            }
            if (type === 'radio') {
              let product;
              if (isBundleItem) {
                product = productCustomization['bundle']?.[stepId]?.[productID];
              } else {
                product = productCustomization;
              }

              let condimentInfo = product.items[optionGroup?.id][condiment.id];
              isChecked = !!condimentInfo;

              return (
                <div className={css.main} key={idx}>
                  <List
                    key={optionGroup.id + 'RaidoGroup'}
                    disablePadding
                    className={css.listContainer}
                  >
                    <ProductOption
                      option={condiment}
                      type={type}
                      key={key}
                      id={key}
                      onChange={(event, value) => handleToggle(idx)}
                      checked={isChecked ? true : false}
                    />
                  </List>
                </div>
              );
            }
            if (type === 'stepper' || !isTopping) {
              return (
                <div className={css.main} key={idx}>
                  <List
                    key={optionGroup.id + 'StepperGroup'}
                    disablePadding
                    className={css.listContainer}
                  >
                    <ProductOptionStepper
                      isSingleSelectionOption={isSingleSelectionOption}
                      disabled={selectedToppingsCount >= maximum}
                      option={condiment}
                      type={type}
                      key={key}
                      id={key}
                      main={mainItem}
                      group={optionGroup}
                      checked={isChecked ? true : false}
                      selectedProduct={selectedProduct}
                      productID={productID}
                    />
                  </List>
                </div>
              );
            }
            return '';
          })}
        </div>
      </div>
    </>
  );
}

export default ProductOptionGroup;
